export const LOCALES = [
  { value: "bs", label: "Bosanski", short: "BS", flag: "\u{1F1E7}\u{1F1E6}" },
  { value: "en", label: "English", short: "EN", flag: "\u{1F1EC}\u{1F1E7}" },
] as const;

export const LOCALE_MAP: Record<string, (typeof LOCALES)[number]> = Object.fromEntries(
  LOCALES.map((l) => [l.value, l])
);
